import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { selfEmploymentSelector } from '../selectors'
import { handleRequestError } from './request'
import { updateAndSaveActiveTaxReturn } from './tax-return'

export const REQUEST_SELF_EMPLOYMENT_SUMMARY = 'REQUEST_SELF_EMPLOYMENT_SUMMARY'
export const RECEIVE_SELF_EMPLOYMENT_SUMMARY = 'RECEIVE_SELF_EMPLOYMENT_SUMMARY'
export const SAVE_SELF_EMPLOYMENT_SUMMARY = 'SAVE_SELF_EMPLOYMENT_SUMMARY'
const CREATE_SELF_EMPLOYMENT_SUMMARY = 'CREATE_SELF_EMPLOYMENT_SUMMARY'

export const requestSelfEmploymentSummary = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_SELF_EMPLOYMENT_SUMMARY, data: { taxReturnId } })

    axios
        .get(`/selfemploymentsummaries/${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveSelfEmploymentSummary({
                    fetchSuccessful: true,
                    ...responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveSelfEmploymentSummary({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveSelfEmploymentSummary({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveSelfEmploymentSummary = (data) => ({ type: RECEIVE_SELF_EMPLOYMENT_SUMMARY, data })

export const saveSelfEmploymentSummary = (data) => (dispatch, getState) => {
    dispatch({ type: SAVE_SELF_EMPLOYMENT_SUMMARY, data })

    const { id: taxReturnId } = getState().taxReturn

    return axios
        .put(`/selfemploymentsummaries/${taxReturnId}`, { ...data, taxReturnId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveSelfEmploymentSummary(responseData))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const updateAndSaveSelfEmploymentSummary = (data) => (dispatch, getState) => {
    const { selfEmploymentSummary } = selfEmploymentSelector(getState())
    const updatedSelfEmploymentSummary = { ...selfEmploymentSummary, ...data }

    dispatch(receiveSelfEmploymentSummary(updatedSelfEmploymentSummary))
    return dispatch(saveSelfEmploymentSummary(updatedSelfEmploymentSummary)).catch(() => {})
}

export const updateAndSaveSelfEmploymentSummaryStatus =
    ({ status }) =>
    (dispatch, getState) => {
        const { selfEmploymentSummary } = selfEmploymentSelector(getState())
        const updatedSelfEmploymentSummary = { ...selfEmploymentSummary, status }

        dispatch(receiveSelfEmploymentSummary(updatedSelfEmploymentSummary))
        return dispatch(saveSelfEmploymentSummary(updatedSelfEmploymentSummary))
            .then(() => dispatch(updateAndSaveActiveTaxReturn({ selfEmploymentSummaryStatus: status })))
            .catch(() => {})
    }

export const createSelfEmploymentSummary =
    (data = {}) =>
    (dispatch, getState) => {
        dispatch({ type: CREATE_SELF_EMPLOYMENT_SUMMARY })

        const { id: taxReturnId } = getState().taxReturn

        return axios
            .put(`/selfemploymentsummaries/${taxReturnId}`, data)
            .then((response) => {
                const responseData = response?.data || {}
                dispatch(receiveSelfEmploymentSummary(responseData))
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
                return Promise.reject(error)
            })
    }

export const createOrUpdateSelfEmploymentSummary = (data) => (dispatch, getState) => {
    const { hasSelfEmploymentSummary, selfEmploymentSummary } = selfEmploymentSelector(getState())

    const persist = hasSelfEmploymentSummary ? updateAndSaveSelfEmploymentSummary : createSelfEmploymentSummary
    return dispatch(persist({ ...selfEmploymentSummary, ...data }))
}
